import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateInventoryItem = createAsyncThunk(
  "InventoryList/updateInventoryItem",
  async (data, thunkAPI) => {
    const { schema, id, handleError, handleSuccess } = data;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/inventory/${id}`,
        schema,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess) {
        handleSuccess();
      }
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
